import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../services/adminService";

export interface LoginCredentials {
  email: string;
  password: string;
  remember_me: boolean;
}

export interface UpdateAdminUserAccount {
  fullName: string | null;
  password: string | null;
  img: string | null;
  userId: string;
}

export interface ViewDashboardProps {
  dateFrom: string | null;
  dateTo: string | null;
}

// Create the login async thunk
export const loginAdminUser = createAsyncThunk(
  "admin/login",
  async (credentials: LoginCredentials, { rejectWithValue }) => {
    const { email, password, remember_me } = credentials;
    try {
      const body = { email, password, remember_me };
      const { data } = await API.adminUserLogin(body);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getOrganizations = createAsyncThunk(
  "admin/companies",
  async (_, { rejectWithValue }) => {
    try {
      return await API.getAllOrganizationsList();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createOrganization = createAsyncThunk(
  "admin/companies/create",
  async ({ requestBody }: any, { rejectWithValue }) => {
    try {
      return await API.createOrganization(requestBody);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateOrganization = createAsyncThunk(
  "admin/companies/update",
  async ({ requestBody, organizationId }: any, { rejectWithValue }) => {
    try {
      return await API.updateOrganization(requestBody, organizationId);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllOrganizationalUsers = createAsyncThunk(
  "admin/organizational-users",
  async (_, { rejectWithValue }) => {
    try {
      return await API.getOrganizationalUsers();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const searchOrganizationalUsers = createAsyncThunk(
  "admin/search-organizational-users",
  async (search: any, { rejectWithValue }) => {
    try {
      return await API.searchOrganizationalUsers(search);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const searchOrganizations = createAsyncThunk(
  "admin/search-organizations",
  async (search: any, { rejectWithValue }) => {
    try {
      return await API.searchOrganizations(search);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateAdminUserAccount = createAsyncThunk(
  "admin/update-admin-user",
  async (credentials: UpdateAdminUserAccount, { rejectWithValue }) => {
    const { fullName, password, img, userId } = credentials;
    try {
      const body = { fullName, password, img };
      const { data } = await API.updateAdminUserAccount(userId, body);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
